import React from 'react'
import {Stack, Flex, Text} from '../../../../vanilla'
import {storeDetailHoursBox} from './style.css'
import { StoreDetailResponseItem, StoreHours } from '../../../../types/store/storeDetails'
const currentDayOfWeekName = new Date().toLocaleString('default', {weekday: 'long'})

export const storeHoursBlock = (store: StoreDetailResponseItem, hoursData: StoreHours[], title:string) => (
    <>
    {hoursData?.length && (
      <Stack
        spacing="8px"
        className={storeDetailHoursBox}
        paddingX={['16px', '0px']}
        paddingY={['12px', '0px']}
      >
        <Text variant="text4" lineHeight="shorter">
          {title}
        </Text>
        <Stack spacing="0px">
          {hoursData.map((hours, idx) => (
            <Flex
              width="full"
              align="center"
              justify="space-between"
              key={`${store.id}-hours-${idx}`}
            >
              <Text
                variant="text3"
                lineHeight="shorter"
                as="span"
                textTransform={'capitalize'}
                color={
                  hours.day === currentDayOfWeekName.toLowerCase()
                    ? 'accent1'
                    : 'gray800'
                }
              >
                {hours.day}
              </Text>
  
              <Text
                variant="text3"
                lineHeight="shorter"
                as="span"
                color={
                  hours.day === currentDayOfWeekName.toLowerCase()
                    ? 'accent1'
                    : 'gray800'
                }
              >
                {hours.isClosed ? "CLOSED" : `${hours.open} - ${hours.close}`}
              </Text>
            </Flex>
          ))}
        </Stack>
      </Stack>
    )}
    </>
  )
